import React from 'react';

class IconInfo extends React.Component {
  render() {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 10.5C17.5 11.3284 16.8284 12 16 12C15.1716 12 14.5 11.3284 14.5 10.5C14.5 9.67157 15.1716 9 16 9C16.8284 9 17.5 9.67157 17.5 10.5Z"
          fill="#8A8B8D"
        />
        <path
          d="M13 15H15.5V21H13V23H19V21H17.5V15C17.5 13.8954 16.6046 13 15.5 13H13V15Z"
          fill="#8A8B8D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5556 5H16.4444C18.0869 4.99999 19.3809 4.99999 20.4222 5.08507C21.4846 5.17186 22.3717 5.35217 23.1779 5.76295C24.4951 6.43407 25.5659 7.50493 26.237 8.82207C26.6478 9.62827 26.8281 10.5154 26.9149 11.5778C27 12.6191 27 13.913 27 15.5556V16.4444C27 18.087 27 19.3809 26.9149 20.4222C26.8281 21.4846 26.6478 22.3717 26.237 23.1779C25.5659 24.4951 24.4951 25.5659 23.1779 26.237C22.3717 26.6478 21.4846 26.8281 20.4222 26.9149C19.3809 27 18.087 27 16.4444 27H15.5556C13.913 27 12.6191 27 11.5778 26.9149C10.5154 26.8281 9.62827 26.6478 8.82207 26.237C7.50493 25.5659 6.43407 24.4951 5.76295 23.1779C5.35217 22.3717 5.17186 21.4846 5.08507 20.4222C4.99999 19.3809 4.99999 18.087 5 16.4444V15.5556C4.99999 13.9131 4.99999 12.6191 5.08507 11.5778C5.17186 10.5154 5.35217 9.62827 5.76295 8.82207C6.43407 7.50493 7.50493 6.43407 8.82207 5.76295C9.62827 5.35217 10.5154 5.17186 11.5778 5.08507C12.6191 4.99999 13.9131 4.99999 15.5556 5ZM11.7406 7.07842C10.802 7.15512 10.2073 7.30179 9.73005 7.54497C8.78924 8.02433 8.02433 8.78924 7.54497 9.73005C7.30179 10.2073 7.15512 10.802 7.07842 11.7406C7.00078 12.691 7 13.9033 7 15.6V16.4C7 18.0967 7.00078 19.309 7.07842 20.2594C7.15512 21.198 7.30179 21.7927 7.54497 22.27C8.02433 23.2108 8.78924 23.9757 9.73005 24.455C10.2073 24.6982 10.802 24.8449 11.7406 24.9216C12.691 24.9992 13.9033 25 15.6 25H16.4C18.0967 25 19.309 24.9992 20.2594 24.9216C21.198 24.8449 21.7927 24.6982 22.27 24.455C23.2108 23.9757 23.9757 23.2108 24.455 22.27C24.6982 21.7927 24.8449 21.198 24.9216 20.2594C24.9992 19.309 25 18.0967 25 16.4V15.6C25 13.9033 24.9992 12.691 24.9216 11.7406C24.8449 10.802 24.6982 10.2073 24.455 9.73005C23.9757 8.78924 23.2108 8.02433 22.27 7.54497C21.7927 7.30179 21.198 7.15512 20.2594 7.07842C19.309 7.00078 18.0967 7 16.4 7H15.6C13.9033 7 12.691 7.00078 11.7406 7.07842Z"
          fill="#8A8B8D"
        />
      </svg>
    );
  }
}

export default IconInfo;
